import styled from 'styled-components';

import BG from '@assets/images/promotions/promotion_single_winner.webp';
import mobileBG from '@assets/images/promotions/promotion_single_winner_mob.webp';

export const Wrapper = styled.div`
	padding: 32px 0;
	width: 100%;
	border-radius: 12px;
	background-color: ${({ theme }) => theme.colors.background.secondary};

	display: flex;
	flex-direction: column;
	align-items: center;
	position: relative;

	overflow: hidden;

	text-align: center;

	background-image: url('${BG}');
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;

	@media (max-width: 992px) {
		padding: 23px 16px;
		align-items: start;

		background-image: url('${mobileBG}');
		background-position: right;
		background-size: cover;
	}
`;

export const PlaceChip = styled.div`
	display: inline-block;

	padding: 6px 8px;
	border-radius: 16px;
	background-color: ${({ theme }) => theme.colors.transparent.light10};

	font-size: 14px;
	line-height: 19px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	text-transform: lowercase;

	margin-bottom: 16px;

	@media (max-width: 992px) {
		padding: 4px 6px;
		font-size: 12px;
		line-height: 16px;
		margin-bottom: 8px;
	}
`;

export const Participant = styled.p`
	font-size: 20px;
	line-height: 27px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.title};
	margin-bottom: 8px;

	@media (max-width: 992px) {
		font-size: 16px;
		line-height: 22px;
		margin-bottom: 4px;
	}
`;

export const Name = styled.div`
	font-size: 28px;
	line-height: 38px;
	font-weight: 700;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	margin-bottom: 14px;

	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;

	@media (max-width: 992px) {
		font-size: 16px;
		line-height: 22px;
		margin-bottom: 8px;

		gap: 4px;

		justify-content: flex-start;
	}
`;

export const Prize = styled.p`
	font-size: 24px;
	line-height: 33px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.title};

	margin-bottom: 4px;
`;

export const CupIconWrapper = styled.div`
	width: 28px;
	height: 28px;

	svg {
		width: 28px;
		height: 28px;
	}

	path {
		fill: ${({ theme }) => theme.colors.icon.main};
	}

	@media (max-width: 992px) {
		width: 16px;
		height: 16px;

		svg {
			width: 16px;
			height: 16px;
		}
	}
`;
